import React from "react";
import { Link } from "react-router-dom";

const Columns = (remove, disable) => [
  {
    dataField: "user.givenName",
    text: "Transportista / proveedor",
    sort: true,
  },
  {
    dataField: "user.email",
    text: "Email contacto",
    sort: true,
  },
  {
    dataField: "number",
    text: "Número",
    sort: true,
  },
  {
    dataField: "openingDateOnly",
    text: "Fecha alta",
    sort: true,
  },
  {
    dataField: "menu",
    isDummyField: true,
    text: "Acciones",
    style: { width: "5%" },
    formatter: (cellContent, row) => (
      <div className="d-flex align-item">
        <Link to={`/box/edit/${row.id}`} className="me-3 text-primary">
          <i className="mdi mdi-pencil font-size-18"></i>
        </Link>
        <Link to="#" onClick={() => remove(row.id)} className="text-danger">
          <i className="mdi mdi-trash-can font-size-18"></i>
        </Link>

        {row?.available && (
          <>
            <Link
              to="#"
              onClick={() => disable(row.id)}
              className="text-danger ms-3"
            >
              <i class="mdi mdi-minus-circle font-size-18" title="Desactivar"></i>
            </Link>
          </>
        )}
      </div>
    ),
  },
];

export default Columns;
